import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import axios from 'axios'

//Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//For Language
import locale from 'element-ui/lib/locale/lang/en'

//Charts
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

//External File
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/style.css'

//Dropzone
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

Vue.config.productionTip = false

// axios.defaults.baseURL = 'http://jpicp.test/include/api/'
axios.defaults.baseURL = 'https://pbseducation.com/include/api/'

Vue.prototype.$axios = axios

//Use
Vue.use(ElementUI , { locale })
Vue.use(Chartkick.use(Chart))
Vue.use(vue2Dropzone)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
